<template>
    <app-layout :title="$page.props.product.product_name ?? 'Product'">

        <template #fluid>
            <browse-drawer />
        </template>
       
         <ol class="breadcrumb bg-transparent p-0 mb-4">
            <li class="breadcrumb-item"><a href="">Product</a></li>
            <li class="breadcrumb-item" v-for="crumb in $page.props.category_crumb" :key="crumb.id">
                    <a :href="route('products',{id:crumb.id})"> {{crumb.category_name}}</a>
                </li>
            <li class="breadcrumb-item active" aria-current="page">{{$page.props.product.product_name}}</li>
        </ol>

       <div class="row pt-4">
           <div class="col-md-5">
               <div class="carousel slide" data-ride="carousel" id="bs-carousel">
                    <div class="carousel-inner">
                        
                        <div :class="`carousel-item `+ (imgIdx == 0 ? 'active' : '')"
                            v-for="(image, imgIdx) in gallery_images" :key="`carousel-gallery-${imgIdx}`"
                            >
                            <img v-if="image.mediaType != 'video'" class="d-block w-100" :srcset="image.src" style="width:480px;height:480px;object-fit:contain;">
                            <template v-else>
                                <iframe style="border:none;" width="100%" height="480" 
                                    v-if="image.src.toLowerCase().indexOf('youtu') > -1"
                                    :src="`${image.src}`">
                                </iframe>
                                <video width="480" height="480" class="mx-1" v-else controls>
                                    <source :src="image.src" >
                                    Your browser does not support the video tag.
                                </video>
                            </template>
                        </div>
                        
                        <a class="carousel-control-prev" href="#bs-carousel" role="button" data-slide="prev" style="height:60%; top:20%">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#bs-carousel" role="button" data-slide="next" style="height:60%; top:20%">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>

                    <ul class="carousel-indicators">
                        <li v-for="(image, imgIdx) in gallery_images" :key="`gallery-thumb-${imgIdx}`" :class="' ' + (imgIdx == 0 ? 'active' : '')">
                            <a :class="' ' + (imgIdx == 0 ? 'selected' : '')" :data-slide-to="imgIdx" data-target="#bs-carousel">
                                <img v-if="image.mediaType != 'video'" :srcset="image.thumb" class="img-fluid">
                                <img v-else :src="image.thumb" class="img-fluid bg-dark">
                            </a>
                        </li>
                    </ul>
                </div>
           </div>

           <!-- ## TODO: show more product info -->
           <div class="col-md-6 ">
               <h3>{{$page.props.product.product_name}}</h3>
                <hr/>
                <p>Product Code: {{$page.props.product.payrecon_product_id}}</p>
                <div class="row mt-1" style="font-size:10pt;" v-if="product.product_summary">
                    <div class="container-fluid">
                        <span class="h6 text-capitalize"><u>short Description</u></span><br/>
                        <div v-html="product.product_summary"></div>
                    </div>
                </div>
                
                <div class="row mt-1" style="font-size:10pt;" v-if="product.brand">
                    <div class="container-fluid row m-0">
                        <span class="h6 text-capitalize text-bold"><u>brand</u></span>
                        <span class="pl-1 pr-2">:</span>
                        <span>{{product.brand}}</span>
                    </div>
                </div>

                <div class="row mt-1" style="font-size:10pt;" v-if="parseFloat(product.width) + parseFloat(product.length) + parseFloat(product.height)">
                    <div class="container-fluid row m-0">
                        <span class="h6 text-capitalize"><u>dimension (CM)</u></span>
                        <span class="pl-1 pr-2">:</span>
                        <span>{{(product.width)}} (W) X {{product.length}} (L) X {{product.height}} (H)</span>
                    </div>
                </div>

                <div class="row mt-1" style="font-size:10pt;" v-if="parseFloat(product.weight)">
                    <div class="container-fluid row m-0">
                        <span class="h6 text-capitalize"><u>weight</u></span>
                        <span class="pl-1 pr-2">:</span>
                        <span>{{parseFloat(product.weight)}} (KG)</span>
                    </div>
                </div>

                <div class="row mt-1" style="font-size:10pt;" v-if="product.content">
                    <div class="container-fluid row m-0">
                        <span class="h6 text-capitalize"><u>content</u></span>
                        <span class="pl-1 pr-2">:</span>
                        <span>{{product.content}}</span>
                    </div>
                </div>
                
                <div class="row m-0 mt-2" style="font-size:12px;">
                
                    <div class="col bg-light border-bottom border-primary text-primary py-2" v-for="attr in $page.props.product.group_attr" :key="attr.index">
                        {{attr}}
                    </div>
                    <div class="col bg-light border-bottom border-primary text-primary py-2">
                        Dropship Price: 
                    </div>
                    <div class="col-4 bg-light border-bottom border-primary text-primary py-2">
                        Suggested Selling Price:
                    </div>
                    <div class="col bg-light border-bottom border-primary text-primary py-2">
                        Stock:
                    </div>
                </div>

                <div class="row m-0" v-for="vr in $page.props.variants" :key="vr.id">
                    <div class="col  border-bottom border-primary py-2" v-for="vr_attr in vr.variant_attr_arr" :key="vr_attr.index">
                        <b class="text-primary" >{{vr_attr.value}}</b>
                    </div>
                    <div class="col  border-bottom border-primary py-2"> <b class="text-primary">{{$page.props.currency}} {{vr.variant_price}} </b></div>
                    <div class="col-4  border-bottom border-primary py-2"><b class="text-primary">{{$page.props.currency}} {{vr.variant_recommended_price}} </b></div>
                    <div class="col  border-bottom border-primary py-2"><b class="text-primary">{{vr.variant_stock}} </b></div>
                </div>

                <br/>
                <h3><span class="badge badge-success">{{$page.props.product.profit_margin}} Profit</span></h3>
                <br/>
                <div>
                    <div class="alert alert-success" v-if="$page.props.flash.message">
                        {{ $page.props.flash.message }}
                    </div>
                    <div class="alert alert-danger" v-if="$page.props.flash.error_message">
                        {{ $page.props.flash.error_message }}
                    </div>
                </div>

                <div v-if="$page.props.isLogin">
                    <button v-show="$page.props.addedpayrecon==0" class="btn btn-primary rounded-0 hvr-float"  @click="openModal()"><i class="fas fa-plus-square"></i> Add to My Store</button>
                
                    <button v-show="$page.props.addedpayrecon>0" class="btn btn-success rounded-0 hvr-float" disabled><i class="fas fa-check"></i> Added to My Store</button>
                
                    <button v-show="$page.props.addedpayrecon>0" class="btn btn-secondary rounded-0 text-white hvr-float" @click="openPayrecon()"><i class="fas fa-external-link-alt"></i> View Product on PayRecon</button>
                </div>

                <inertia-link v-else class="btn btn-secondary rounded-0 hvr-float" :href="route('login.payrecon', {'product': $page.props.product.id})" ><i class="fas fa-user"></i> Login to Add </inertia-link>

              <div class="modal fade " id="pop-modal" v-if="$page.props.isLogin" tabindex="-1" role="dialog" aria-hidden="true"  data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content" >
                            <div class="modal-header border-bottom-0">
                                <h5 class="modal-title" id="exampleModalLabel">Are you sure?</h5>
                                <button type="button" class="close" @click="closeModal()" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <form>
                            <div class="modal-body">
                                <!-- <p v-if="$page.props.addedpayrecon == 0">Add to Payrecon Account [{{$page.props.user.name}}]</p> -->
                                <!-- <p v-else>Remove from Payrecon Account [{{$page.props.user.name}}]</p> -->
                                <img :srcset="$page.props.product.product_cover_image" class="img-fluid"/>
                                <p class="text-center">{{$page.props.product.product_name}}</p>



                            </div>
                                <div class="modal-footer border-top-0 d-flex justify-content-center">
                                <button  type="button" class="btn btn-success" v-show="$page.props.addedpayrecon==0" @click="save(form)">
                                    Push to Payrecon
                                </button>

                                <!-- <button type="button" class="btn btn-danger" v-show="$page.props.addedpayrecon>0" @click="unlink(form)">
                                    Remove From Payrecon
                                </button> -->

                                    <button @click="closeModal()" type="button" class="btn btn-primary">
                                    Cancel
                                </button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>


            </div>

       </div>

       <ul class="nav nav-pills mt-5 border-bottom border-primary" id="pills-tab" role="tablist">
            <li class="nav-item">
                <a class="nav-link active rounded-0" id="pills-home-det" data-toggle="pill" href="#pills-det" role="tab" aria-controls="pills-det" aria-selected="true">Description</a>
            </li>
            <li class="nav-item" v-if="shippingInfo">
                <a class="nav-link rounded-0" id="pills-shipping-tab" data-toggle="pill" href="#pills-shipping" role="tab" aria-controls="pills-shipping" aria-selected="false">Shipping</a>
            </li>
            <li class="nav-item" v-if="returnPolicy">
                <a class="nav-link rounded-0" id="pills-return-tab" data-toggle="pill" href="#pills-return" role="tab" aria-controls="pills-return" aria-selected="false">Return Policy</a>
            </li>
        </ul>
        <div class="tab-content" id="pills-tabContent" style="min-height:500px;">
            <div class="tab-pane fade show active p-3" id="pills-det" role="tabpanel" aria-labelledby="pills-det-tab" >

                <div v-if="$page.props.variants.length">
                    <div v-html="$page.props.product.product_desc"></div>
                </div>
                <div v-else>
                    No description.
                </div>

            </div>
            <div class="tab-pane fade  p-3" id="pills-shipping" role="tabpanel" aria-labelledby="pills-shipping-tab" v-html="shippingInfo"></div>
            <div class="tab-pane fade  p-3" id="pills-return" role="tabpanel" aria-labelledby="pills-return-tab" v-html="returnPolicy"></div>
        </div>
        
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import BrowseDrawer from '@/Layouts/BrowseDrawer.vue'
    
    export default {
        components: {
            AppLayout,
            BrowseDrawer,
        },
        props:{      
            product: new Object,
            variants: Array
        },
        computed:{
            shippingInfo(){
                // i think this is wrong
                // $page.props.global_config.product.shipping
                return this.$page.props.global_config.shipping ?? ''
            },
            returnPolicy(){
                // $page.props.global_config.product.return_policy
                return this.$page.props.global_config.return_policy ?? ''
            },
            gallery_images(){
                const gallery = []

                if(this.product.product_cover_image){
                    gallery.push({
                        src: this.product.product_cover_image,
                        thumb: this.product.product_cover_image,
                        type: 'image'
                    })
                }
                
                // test none youtube
                // gallery.push({
                //     // src: "https://download.blender.org/peach/trailer/trailer_1080p.ogg",
                //     src: "https://download.blender.org/peach/trailer/trailer_400p.ogg",
                //     thumb: "/images/video-thumb.png",
                //     mediaType: 'video'
                // })

                if(this.product.extras.video){
                    gallery.push({
                        src: this.product.extras.video,
                        thumb: "/images/video-thumb.png",
                        mediaType: 'video'
                    })
                }
                
                if(this.product.product_images.length){
                    this.product.product_images.map(image => {
                        gallery.push({
                            src: image,
                            thumb: image,
                            type: 'image'
                        })
                    })
                }
                
                return gallery
            },
        },
        data(){
            return {
                form: {
                    product_id: this.product.id
                },
                dialogModel: false,
            }
        },
        methods:{
            openPayrecon(){
                if(this.$page.props.payrecon_app) window.open(`${this.$page.props.payrecon_app}/products/dropship-list`);
            },
            openModal: function () {
                // this.dialogModel = true
                $("#pop-modal").modal('show')
            },
            closeModal: function () {
                // this.dialogModel = false
                $("#pop-modal").modal('hide')
            },
            save: function (data) {
                this.$inertia.post('/payrecon-products', data, {
                    onSuccess: page => {
                        this.closeModal();
                    },
                })   
                
            },
            unlink: function (data) {
                data._method = 'DELETE';
                this.$inertia.post('/payrecon-products' + data.id, data,{
                     preserveScroll:true
                })
                this.closeModal();
            }
        }

        
        
    }
</script>